"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Linkedin, Youtube, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const fallbackColumns = [{
    id: 'fallback-1',
    label: "Kako radi",
    children: [{
      id: 'f1-1',
      label: "Prednosti",
      href: "#"
    }, {
      id: 'f1-2',
      label: "Značajke",
      href: "#"
    }, {
      id: 'f1-3',
      label: "Cijene",
      href: "#"
    }, {
      id: 'f1-4',
      label: "Partneri",
      href: "#"
    }]
  }, {
    id: 'fallback-2',
    label: "Kontakt",
    children: [{
      id: 'f2-1',
      label: "Podrška",
      href: "#"
    }, {
      id: 'f2-2',
      label: "Prodaja",
      href: "#"
    }, {
      id: 'f2-3',
      label: "Demo",
      href: "#"
    }, {
      id: 'f2-4',
      label: "Ured",
      href: "#"
    }]
  }, {
    id: 'fallback-3',
    label: "Tvrtka",
    children: [{
      id: 'f3-1',
      label: "O nama",
      href: "/HomePage"
    }, {
      id: 'f3-2',
      label: "Vodstvo",
      href: "#"
    }, {
      id: 'f3-3',
      label: "Karijere",
      href: "#"
    }, {
      id: 'f3-4',
      label: "Kontaktirajte nas",
      href: "#"
    }]
  }, {
    id: 'fallback-4',
    label: "Resursi",
    children: [{
      id: 'f4-1',
      label: "Blog",
      href: "#"
    }, {
      id: 'f4-2',
      label: "Studije slučaja",
      href: "#"
    }, {
      id: 'f4-3',
      label: "Bijele knjige",
      href: "#"
    }, {
      id: 'f4-4',
      label: "Webinari",
      href: "#"
    }]
  }, {
    id: 'fallback-5',
    label: "Pravno",
    children: [{
      id: 'f5-1',
      label: "Politika privatnosti",
      href: "/PrivacyPolicyPage"
    }, {
      id: 'f5-2',
      label: "Uvjeti korištenja",
      href: "/TermsOfUsePage"
    }, {
      id: 'f5-3',
      label: "Uvjeti pružanja usluge",
      href: "#"
    }]
  }];
  if (loading) {
    return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
        {[1, 2, 3, 4, 5].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-5 w-24 bg-white/10 animate-pulse rounded-md" />
            <div className="flex flex-col gap-3">
              {[1, 2, 3, 4].map((_, j) => <div key={j} data-index={j} className="h-4 w-full max-w-[120px] bg-white/10 animate-pulse rounded-md" />)}
            </div>
          </div>)}
      </div>;
  }
  const displayItems = menuItems && menuItems.length > 0 ? menuItems : fallbackColumns;
  return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
      {displayItems.map((col, i) => <div key={col.id} data-index={i} className="flex flex-col gap-4">
          <h4 className="font-default text-lg font-semibold text-white">{col.label}</h4>
          {col.children && col.children.length > 0 && <ul className="flex flex-col gap-3">
              {col.children.map((link, j) => <li key={link.id} data-index={j}>
                  <Link to={link.href || "#"} className="text-base leading-[2.0] text-white/80 hover:text-white transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>}
        </div>)}
    </div>;
}
export default function Footer() {
  return <section data-section-id="252382" id="podnožje-stranice" className="dark bg-[#011466] text-white py-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-16">
          <div className="flex flex-col gap-6 max-w-md">
            <Link to="/HomePage">
              <WvcLogo className="h-8 w-auto brightness-0 invert" />
            </Link>
            <p className="text-base leading-relaxed text-white/90">
              Izvrsnost nikada nije slučajna: ona je uvijek rezultat visoke namjere, iskrenog truda, inteligentnog usmjeravanja i vješte izvedbe.
            </p>
            <div className="flex gap-4">
              
              
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Link to="https://www.linkedin.com/company/tech-start-hr/" newTab className="flex items-center justify-center size-10 rounded-lg bg-[#022CE6] text-white hover:bg-[#022CE6]/80 transition-all duration-300 shadow-md" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
            <Link to="https://www.instagram.com/mobileo_hr" newTab className="flex items-center justify-center size-10 rounded-lg bg-[#022CE6] text-white hover:bg-[#022CE6]/80 transition-all duration-300 shadow-md" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>

        {}

        {}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/70">
          <p>© 2026&nbsp;Techstart. Sva prava pridržana.</p>
          <div className="flex gap-6">
            <Link to="/PrivacyPolicyPage" className="hover:text-white transition-colors">Politika privatnosti</Link>
            <Link to="/TermsOfUsePage" className="hover:text-white transition-colors">Uvjeti korištenja</Link>
            <Link to="/ContactUsPage" className="hover:text-white transition-colors">Kontakt</Link>
          </div>
        </div>
      </div>
    </section>;
}